import React, {FC, useEffect, useRef} from 'react';
import {useAppSelector} from '../hooks/storeHooks';
import {Translation} from '../contexts/Configuration';

import './Recognition.scss';

const TranslationHistoryCast: FC<TranslationHistoryCastProps> = ({id, translations}) => {

    const lastElemId = `cast-last-${id}`;
    const bottomEl = useRef<HTMLInputElement>(null);
    const containerEl = useRef<HTMLInputElement>(null);
    const scrollToBottom = () => {
        // console.log(id, ' scrollToBottom -> ', bottomEl?.current)

        containerEl?.current?.scrollTo(
            0, bottomEl?.current?.offsetTop || 0
            // false => scrollIntoViewOptions: {block: "end", inline: "nearest"}
            /*{block: "end", inline: "nearest"}*/
            // {block: "end", inline: "end", behavior: 'smooth'}
        );
    };
    useEffect(() => {
        scrollToBottom()
        // console.log( id, ' -> ', bottomEl?.current)
    }, [id, translations.length]);


    const getTranscribedSpeechBubbles = () => {
        return translations.length > 0 ? translations
            .filter(translation => !!translation)
            .map((translation, index) => {
                return (
                    <div className="recognition-item" key={`cast_${id}_trans_${index}`}>
                        <div className="recognition-item-text">
                            {translation || 'N/A'}
                        </div>
                    </div>
                )
            }) : <></>
    }

    //Lista de recognitions
    return (
        <div id={'cast-recognition_history-' + id} className="recognition-container">
            <div id={'cast-recognition_content-' + id} className="recognition-content" ref={containerEl}>
                {getTranscribedSpeechBubbles()}
                <div id={lastElemId} ref={bottomEl}/>
            </div>
        </div>
    );
};

type TranslationHistoryCastProps = {
    id: string,
    translations: string[]
}

export default TranslationHistoryCast;
